import matchedRoutes from '../routes'
import React from 'react'
import Layout from './layouts/index'

export function onRouteChange({ matchedRoutes }: { matchedRoutes: any[] }) {
  if (matchedRoutes.length) {
    document.title = matchedRoutes[matchedRoutes.length - 1].route.title || ''
  }
}

export function rootContainer(container: React.ReactNode) {
  return React.createElement('div', null, <Layout>{container}</Layout>)
}
